<template lang="">
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Start Header
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
<header class="header-section">
    <div class="container-fluid">
        <nav>
            <a class="site-logo site-title" href="https://appdevs.net/app/documentation"><img src="/product/efunding/documentation/assets/images/logo/logo.webp" alt="site-logo"><span class="logo-badge">Docs</span></a>
            <div class="header-action-wrapper">
                <ul class="header-list ms-auto">
                    <li><a href="https://appdevs.net/buy-installation" target="_black">Buy Installation</a></li>
                    <li><a href="https://calendly.com/appdevsx/30min" target="_black">Get Customization</a></li>
                    <li><a href="https://appdevs.net/submit-ticket" target="_black">Support</a></li>
                </ul>
                <div class="header-social">
                    <ul class="header-social-list">
                        <li class="header-social-label"><span>Follow us:</span></li>
                        <li><a href="https://codecanyon.net/user/appdevsx/follow" target="_blank"><img src="/product/efunding/documentation/assets/images/follow/codecanyon.webp" alt="icon"></a></li>
                        <li><a href="https://www.facebook.com/appdevsx" target="_blank"><img src="/product/efunding/documentation/assets/images/follow/facebook.webp" alt="icon"></a></li>
                        <li><a href="https://www.youtube.com/@appdevsx" target="_blank"><img src="/product/efunding/documentation/assets/images/follow/youtube.webp" alt="icon"></a></li>
                        <li><a href="https://bd.linkedin.com/company/appdevs" target="_blank"><img src="/product/efunding/documentation/assets/images/follow/linkedin.webp" alt="icon"></a></li>
                    </ul>
                </div>
                <div class="header-action">
                    <a href="https://appdevs.net/blog" target="_blank" class="btn--base">Read Article <i class="las la-angle-right"></i></a>
                </div>
            </div>
            <div class="header-action-wrapper-responsive">
                <button class="header-responsive-btn"><i class="las la-bars"></i></button>
            </div>
        </nav>
    </div>
</header>
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    End Header
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
</template>

<script>
/* eslint-disable no-undef */
export default {
    name: 'HeaderSection',
    mounted(){
        $(document).ready(function() {
            var $headerResponsiveBtn = $(".header-responsive-btn"),
                $bodyOverlay = $(".body-overlay"),
                $headerActionWrapper = $(".header-action-wrapper");

            $headerResponsiveBtn.click(function() {
                toggleHeaderActionWrapper();
            });

            $bodyOverlay.click(function() {
                closeHeaderActionWrapper();
            });

            function toggleHeaderActionWrapper() {
                $headerActionWrapper.toggleClass("active");
                $bodyOverlay.addClass("active");
            }

            function closeHeaderActionWrapper() {
                $bodyOverlay.removeClass("active");
                $headerActionWrapper.removeClass("active");
            }
        });
    }
}
</script>

<style lang="">
    
</style>